import { Model } from 'modules/core/lib/mobx-rest'

interface IScore {
  [key: string]: any
}

class Score extends Model<IScore> {
  static urlRoot() {
    return '/document_split/scores'
  }
}

export default Score
